import { render, staticRenderFns } from "./lista-mini.vue?vue&type=template&id=327325fb&scoped=true&"
import script from "./lista-mini.vue?vue&type=script&lang=ts&"
export * from "./lista-mini.vue?vue&type=script&lang=ts&"
import style0 from "./lista-mini.vue?vue&type=style&index=0&id=327325fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327325fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VList,VListItemGroup})
